<template>
  <div>
    <a-tabs default-active-key="1">
      <a-tab-pane tab="DOTACIONES" key="1">
        <g-master :name="master.endpoint"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :parentData="parentData"
                  :actions="master.actions"
        >
          <template slot="masterModal" slot-scope="{record}">
            <a-row :gutter="[16,16]">
              <a-col v-bind="colOptions">
                  <g-dropdown endpoint="garment_size"
                              :label="$t('Prenda - Talla')"
                              :formItemConfig="fiOptions"
                              :decorator="['id_garment_size', { rules: [{ required: false }] }]"
                              :params="tipo_prenda_talla">
                  </g-dropdown>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha Inicial')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD"
                                 v-decorator="['start_date', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha Fin')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD"
                                 v-decorator="['end_date', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>

              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Fecha Entrega')">
                  <a-date-picker style="width: 100%"
                                 type="date"
                                 valueFormat="Y-MM-DD"
                                 v-decorator="['delivery_date', { rules: [{ required: false }] }]"/>
                </a-form-item>
              </a-col>
              <a-col v-bind="colOptions">
                <a-form-item v-bind="fiOptions" :label="$t('Comentario')">
                  <a-textarea
                    v-decorator="['comments', { rules: [{ required: false, message: 'Valor requerido' }] }]"
                  />
                </a-form-item>
              </a-col>
            </a-row>
          </template>
        </g-master>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>
<script>
  import JsUtils from '../../../../util/JsUtils'

  export default {
    data () {
      return {
        colOptions: {xs: 24, sm: 12},
        fiOptions: {
          'label-col': {},
          'wrapper-col': {}
        },
        tipo_prenda_talla: {
          use_dotacion: true
        },
        master: {
          endpoint: 'emp_dotacion',
          tableSetup: {
            tableConfig: {
              rowKey: 'id'
            },
            columns: [
              {title: 'Tipo De Prenda', dataIndex: 'tipoprenda', sorter: true},
              {title: 'Talla', dataIndex: 'talla', sorter: true},
              {title: 'Fecha Inicio', dataIndex: 'start_date', sorter: true},
              {title: 'Fecha Fin', dataIndex: 'end_date', sorter: true},
              {title: 'Fecha Entrega', dataIndex: 'delivery_date', sorter: true},
              {title: 'Comentarios', dataIndex: 'comments', sorter: true}
            ],
            actions: {
              actions: [
                {
                  name: 'masterEdit',
                  text: 'Editar',
                  permisos: [],
                  props: {size: 'small', type: 'link', icon: 'edit'},
                  fnVisible: (record) => {
                    return this.empleadoseleccionado.status !== 'R'
                  }
                },
                {
                  name: 'masterDelete',
                  text: 'Eliminar',
                  permisos: [],
                  props: {size: 'small', icon: 'delete', type: 'link'},
                  fnVisible: (record) => {
                    return this.empleadoseleccionado.status !== 'R'
                  }
                }
              ]
            }
          },
          actions: [
            {
              name: 'masterCreate',
              text: 'Crear',
              permisos: [],
              props: {icon: 'plus', type: 'button'},
              fnVisible: (record) => {
                return this.empleadoseleccionado.status !== 'R'
              }
            }
          ]
        }
      }
    },
    props: ['empleadoseleccionado'],
    computed: {
      parentData () {
        return {
          id_emp: this.empleadoseleccionado.id_emp
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Dotaciones/DotacionesEmpleado.vue